import { ShopOutlined, UserOutlined } from '@ant-design/icons';
import { Alert, Card, Flex } from 'antd';
import { getSortedIndividualsForDisplay } from 'api/btlApplicationForm/borrowerHelpers';
import { useIntl } from 'react-intl';
import { BtlApplication } from '../../../api/btlApplicationForm/types';
import { TypedFormatMessageFn } from '../../../types/intl';
import { CompanyDescription } from '../Applicants/Company/CompanyCard';
import { IndividualDescription } from '../Applicants/Individual/IndividualCard';

export function ApplicantsSummary({ data }: { data?: BtlApplication }) {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();
  const companies = data?.borrower.companies;
  const individuals = data?.borrower ? getSortedIndividualsForDisplay(data.borrower) : [];

  if (individuals?.length === 0 && companies?.length === 0) {
    return (
      <Alert
        message={formatMessage({ id: 'btlApplicationForm.CASE_SUMMARY.noApplicants.label' })}
        type='info'
        showIcon
      />
    );
  }

  return (
    <Flex gap={16} vertical>
      {companies?.map((company, index) => {
        return (
          <Card
            key={index}
            className={'w-fit'}
            type={'inner'}
            title={
              <>
                <ShopOutlined /> {company.companyName} ({company.companyNumber})
              </>
            }
          >
            <CompanyDescription key={index} company={company} />
          </Card>
        );
      })}
      <Flex wrap gap={16}>
        {individuals.map((individual, index) => {
          return (
            <Card
              key={individual.id ?? index}
              type={'inner'}
              title={
                <>
                  <UserOutlined /> {individual.title} {individual.firstName} {individual.lastName}
                </>
              }
            >
              <IndividualDescription key={index} individual={individual} />
            </Card>
          );
        })}
      </Flex>
    </Flex>
  );
}
